import { AttributeStatus } from 'companySettings/enums';
import { IPartFinderAttribute, IPartFinderAttributePayload } from 'companySettings/types';

import { IUpsertPartFinderAttributeFormData } from './types';

// An edit also sends the revision it was made on, so the server can refuse it when someone else
// saved the list in the meantime.
export const mapPartFinderAttributePayload = (
  data: IUpsertPartFinderAttributeFormData,
  status: AttributeStatus,
  attribute?: IPartFinderAttribute
): IPartFinderAttributePayload => ({
  ...(attribute && { id: attribute.id, revision: attribute.revision }),
  name: data?.name?.trim(),
  status,
  type: data?.type,
  values: data?.values ?? [],
});
